import { TranslateService } from '@ngx-translate/core';

export abstract class TranslationHelper {
  protected abstract translationPath: string;

  constructor(
    private _translateService: TranslateService,
  ) {}

  public translate(key: string): string {
    return this._translateService.instant(`${this.translationPath}.${key}`);
  }
}